module.exports = __webpack_public_path__ + "static/img/Marata-Niukore.1a526de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marata-Niukore.jpg
// module id = 7Fio
// module chunks = 0